const content = "_content_md016_17";
const destructive = "_destructive_md016_43";
const success = "_success_md016_48";
const styles = {
  content,
  destructive,
  success
};
export {
  content,
  styles as default,
  destructive,
  success
};
//# sourceMappingURL=BigIcon.module.css.js.map
